import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../config/config';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {PageEvent} from '@angular/material/paginator';
import {KfRegistration} from '../../../shared/models/kf-registration.interface';

@Component({
  selector: 'app-kf-registration-table',
  templateUrl: './kf-registration-table.component.html',
  styleUrls: ['./kf-registration-table.component.scss']
})
export class KfRegistrationTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['year', 'keyFigures', 'b2bb2c', 'status', 'actions'];

  @Input()
  kfRegistration!: KfRegistration[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadKfRegistrations: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatSort)
  sort!: MatSort;


  constructor(private readonly router: Router) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadKfRegistrations.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadKfRegistrations.emit({page: event.pageIndex, size: event.pageSize});
  }

  goToEdit(kfRegistration: KfRegistration): void {
    let keyFigure;
    if (kfRegistration.keyFigures === 'Put On Market') {
      keyFigure = 'putonmarket';
    }
    else if (kfRegistration.keyFigures === 'Collected') {
      keyFigure = 'collected';
    }
    else if (kfRegistration.keyFigures === 'Cost') {
      keyFigure = 'cost';
    }
    else {
      keyFigure = 'recycling';
    }

    if (this.router.url.includes('country')) {
      this.router.navigate(['kfdataentry/country/kfregistration/' + keyFigure + '/' + kfRegistration.year]).then(
        () => {
          // do nothing
        }
      );
    }
    else {
      this.router.navigate(['kfdataentry/weeesystem/kfregistration/' + keyFigure + '/' + kfRegistration.year]).then(
        () => {
          // do nothing
        }
      );
    }
  }
}
